import {combineReducers} from "redux";
import result from "./result";
import draw from "./draw";
const resultTnReducer = combineReducers({
    result, draw
});

export default resultTnReducer;
